import {PANELMANAGER_CLEAR_PANELPROPS} from '../../constants';


export type ClearPanelPropsAction = {
    type : typeof PANELMANAGER_CLEAR_PANELPROPS;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {Object} panelProps
 *
 * @return {ClearPanelPropsAction}
 */
export default function clearPanelProps( panelKey : string ) : ClearPanelPropsAction {
    return {
        type: PANELMANAGER_CLEAR_PANELPROPS,
        panelKey
    };
}

export type ClearPanelProps = typeof clearPanelProps;
